import { useEffect, useRef, useState } from "react";
import { Fetch } from "../../../shared/Fetch";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

interface IProps {
    reload: boolean;
    toast: any
}

export interface IMassMailWaitTimeSetting {
    id?: number,
    next_Mass_Mail_Wait_Time?: number | null,
    updated_By?: string,
    updated_At?: Date,
}

export const EmptyMassMailSetting: IMassMailWaitTimeSetting = {
    next_Mass_Mail_Wait_Time: null,
};

export const NextMassMailWaitTimeSettingTable = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false, } as { tableData: Array<IMassMailWaitTimeSetting>; loading: boolean });
    const dt = useRef<any>(null);

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("MassMail/getNextMailsSendingMinutesSetting", "GET", null, null, props.toast);
        if (response) {
            const data: Array<IMassMailWaitTimeSetting> = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    };

    // reset(EmptyMassMailSetting);
    useEffect(() => {
        loadTableData();
    }, [props.reload]);

    return (
        <>
            <DataTable style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0", }}
                size="small" ref={dt} value={tableData.tableData} emptyMessage="No Data found."
                loading={tableData.loading} showGridlines stripedRows responsiveLayout="scroll"
            >
                <Column field="next_Mass_Mail_Wait_Time" header="Next Mass Mail Request Wait Time (in minutes)" />
            </DataTable>
        </>
    );
}